import React, { useEffect, useState } from "react";

//redux
import { connect, useDispatch, useSelector } from "react-redux";

//action
import {
    getRestrictedAccount,
    deleteRestrictedAccount,
    updateRestrictedAccountStatus,
} from "../../store/restrictedAccount/action";

//routing
import { Link } from "react-router-dom";

//MUI
import { TablePagination, Tooltip, Switch } from "@material-ui/core";

// type
import { OPEN_RESTRICTED_ACCOUNT_DIALOG } from "../../store/restrictedAccount/types";

// dialog
import RestrictedAccountDialog from "../../component/dialog/RestrictedAccount";

//sweet alert
import { alert, warning, permissionError } from "../../util/Alert";

const TablePaginationActions = React.lazy(() =>
    import("../../component/table/TablePagination")
);

const RestrictedAccountManagement = (props) => {
    const dispatch = useDispatch();
    const [data, setData] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const hasPermission = useSelector((state) => state.admin.admin.flag);

    useEffect(() => {
        props.getRestrictedAccount(); // eslint-disable-next-line
    }, []);

    const restrictedAccounts = useSelector((state) => state.restrictedAccount.restrictedAccounts);

    useEffect(() => {
        setData(restrictedAccounts);
    }, [restrictedAccounts]);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleSearch = (e) => {
        const value = e.target.value.toUpperCase()
            ? e.target.value.trim().toUpperCase()
            : e.target.value.trim();

        if (value) {
            const searchData = restrictedAccounts.filter((data) => {
                return (
                    data?.user?.username?.toUpperCase()?.indexOf(value) > -1 ||
                    data?.user?.uniqueId?.toUpperCase()?.indexOf(value) > -1 ||
                    data?.user?.name?.toUpperCase()?.indexOf(value) > -1
                );
            });
            setData(searchData);
        } else {
            return setData(restrictedAccounts);
        }
    };

    const handleOpen = () => {
        dispatch({ type: OPEN_RESTRICTED_ACCOUNT_DIALOG });
    };

    const handleDelete = (restrictedAccountId) => {
        const data = warning();
        data
            .then((isDeleted) => {
                if (isDeleted) {
                    if (!hasPermission) return permissionError();
                    props.deleteRestrictedAccount(restrictedAccountId);
                    alert("Deleted!", `Restricted account has been deleted!`, "success");
                }
            })
            .catch((err) => console.log(err));
    };

    const handleStatusToggle = (restrictedAccountId, currentStatus) => {
        if (!hasPermission) return permissionError();
        props.updateRestrictedAccountStatus(restrictedAccountId, !currentStatus);
    };

    return (
        <>
            <div className="page-title">
                <div className="row">
                    <div className="col-12 col-md-6 order-md-1 order-last">
                        <h3 className="mb-3 text-white">Restricted Account Management</h3>
                    </div>
                    <div className="col-12 col-md-6 order-md-2 order-first">
                        <nav
                            aria-label="breadcrumb"
                            className="breadcrumb-header float-start float-lg-end"
                        >
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to="/admin/dashboard" className="text-danger">
                                        Dashboard
                                    </Link>
                                </li>
                                <li className="breadcrumb-item active" aria-current="page">
                                    Restricted Account
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <div className="card">
                        <div className="card-header pb-0">
                            <div className="row my-3">
                                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-8 float-left">
                                    <button
                                        type="button"
                                        className="btn waves-effect waves-light btn-danger btn-sm float-left"
                                        onClick={handleOpen}
                                        id="restrictedAccountDialog"
                                    >
                                        <i className="fa fa-plus"></i>
                                        <span className="icon_margin">New</span>
                                    </button>
                                </div>
                                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4 float-right mt-3 mt-lg-0 mt-xl-0">
                                    <form action="">
                                        <div className="input-group mb-3 border rounded-pill">
                                            <div className="input-group-prepend border-0">
                                                <div id="button-addon4" className="btn text-danger">
                                                    <i className="fas fa-search mt-2"></i>
                                                </div>
                                            </div>
                                            <input
                                                type="search"
                                                placeholder="What're you searching for?"
                                                aria-describedby="button-addon4"
                                                className="form-control bg-none border-0 rounded-pill searchBar"
                                                onChange={handleSearch}
                                            />
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div className="card-body card-overflow">
                            <div className="d-sm-flex align-items-center justify-content-between mb-4"></div>

                            <table className="table table-striped">
                                <thead className="text-center">
                                    <tr>
                                        <th>No.</th>
                                        <th>Image</th>
                                        <th>Username</th>
                                        <th>Unique ID</th>
                                        <th>Reason</th>
                                        <th>Active Status</th>
                                        <th>Delete</th>
                                    </tr>
                                </thead>
                                <tbody className="text-center">
                                    {data.length > 0 ? (
                                        (rowsPerPage > 0
                                            ? data.slice(
                                                page * rowsPerPage,
                                                page * rowsPerPage + rowsPerPage
                                            )
                                            : data
                                        ).map((restrictedAccount, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>{page * rowsPerPage + index + 1}</td>
                                                    <td>
                                                        <img
                                                            src={restrictedAccount?.user?.image || "/img/placeholder.png"}
                                                            alt={restrictedAccount?.user?.username}
                                                            style={{
                                                                width: "50px",
                                                                height: "50px",
                                                                borderRadius: "50%",
                                                                objectFit: "cover",
                                                            }}
                                                        />
                                                    </td>
                                                    <td>{restrictedAccount?.user?.username || "-"}</td>
                                                    <td>{restrictedAccount?.user?.uniqueId || "-"}</td>
                                                    <td>
                                                        <Tooltip title={restrictedAccount?.reason || "No reason provided"}>
                                                            <span>
                                                                {restrictedAccount?.reason
                                                                    ? restrictedAccount.reason.length > 30
                                                                        ? restrictedAccount.reason.substring(0, 30) + "..."
                                                                        : restrictedAccount.reason
                                                                    : "-"}
                                                            </span>
                                                        </Tooltip>
                                                    </td>
                                                    <td>
                                                        <Tooltip
                                                            title={
                                                                restrictedAccount.isActive
                                                                    ? "Click to deactivate"
                                                                    : "Click to activate"
                                                            }
                                                        >
                                                            <Switch
                                                                checked={restrictedAccount.isActive}
                                                                onChange={() =>
                                                                    handleStatusToggle(
                                                                        restrictedAccount._id,
                                                                        restrictedAccount.isActive
                                                                    )
                                                                }
                                                                color="primary"
                                                            />
                                                        </Tooltip>
                                                    </td>
                                                    <td>
                                                        <Tooltip title="Delete">
                                                            <button
                                                                type="button"
                                                                className="btn bg-danger btn-sm"
                                                                onClick={() => handleDelete(restrictedAccount._id)}
                                                            >
                                                                <i className="fas text-light fa-trash-alt fa-lg"></i>
                                                            </button>
                                                        </Tooltip>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan="8" align="center">
                                                Nothing to show!!
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            <TablePagination
                                id="pagination"
                                component="div"
                                rowsPerPageOptions={[
                                    5,
                                    10,
                                    25,
                                    100,
                                    { label: "All", value: -1 },
                                ]}
                                count={data.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                SelectProps={{
                                    inputProps: { "aria-label": "rows per page" },
                                    native: true,
                                }}
                                onChangePage={handleChangePage}
                                onChangeRowsPerPage={handleChangeRowsPerPage}
                                ActionsComponent={TablePaginationActions}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <RestrictedAccountDialog />
        </>
    );
};

export default connect(null, {
    getRestrictedAccount,
    deleteRestrictedAccount,
    updateRestrictedAccountStatus,
})(RestrictedAccountManagement);
